/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Redirect, Link } from 'react-router-dom';

@observer
export default class PricingComponent extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 signin">
                        <div className="px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
                            <p className="lead">
                                Ask to enable this feature. Get in touch with our support team.
                            </p>
                            <Link to="/help" className="btn btn-lg btn-block btn-outline-primary">
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
